// extracted by mini-css-extract-plugin
module.exports = {"container":"_24dw6g4ALiwWonqvW2VK-5"};